class ProductAddons extends HTMLElement {
  constructor() {
    super();

    const addonGroups = this.querySelectorAll(".product-addons__group");
    addonGroups.forEach((addonGroup) => {
      addonGroup
        .querySelector(".product-addons__checkbox-input")
        .addEventListener("change", this.checkboxHandler.bind(this))
      
      const inputEl = addonGroup.querySelector(".product-addons__checkbox-input")
      if (inputEl.checked) {
        this.querySelector(".product-addons__collapsable").classList.add("is-open");
      } else {
        this.querySelector(".product-addons__collapsable").classList.remove("is-open");
      }
    });

  }

  checkboxHandler(e) {
    const inputEl = e.currentTarget;
    if (inputEl.checked) {
      this.querySelector(".product-addons__collapsable").classList.add("is-open");
    } else {
      this.querySelector(".product-addons__collapsable").classList.remove("is-open");
    }
  }

}

customElements.define("product-addons", ProductAddons); 